import React, { useEffect, useState } from 'react';
import { SxStyle } from '../../../../types';
import { useStringsContext } from '../../../../contexts/strings';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import DialogContent from '@mui/material/DialogContent';

const styles: SxStyle = {
  title: {
    '&:first-letter': {
      textTransform: 'capitalize',
    },
  },
};

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
}

const SocialCommentWarningModal = ({ isOpen, onClose, onAccept }: Props) => {
  const { strings } = useStringsContext();

  return (
    <Dialog open={isOpen} onClose={onClose} scroll="paper" fullWidth>
      <DialogTitle sx={styles.title}>{strings.social.commentsToggleWarningTitle}</DialogTitle>
      <DialogContent>
        <Typography variant="body1">{strings.social.commentsToggleWarningText}</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={onClose}>
          {strings.actions.noCancel}
        </Button>
        <Button variant="contained" color="error" onClick={onAccept}>
          {strings.actions.yesContinue}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SocialCommentWarningModal;
